var _style, _defs, _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvtLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 758 148",
    style: {
      enableBackground: "new 0 0 758 148"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st1{mask:url(#mask0_373_1318_00000036253612259547506760000003463714704727461550_);}\n\t.st2{fill:#000000;}\n")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 3.6,
    y: 3,
    width: 752,
    height: 141.7
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 3.6,
    y: 3,
    width: 752,
    height: 141.7,
    id: "mask0_373_1318_00000036253612259547506760000003463714704727461550_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M758,0H0v148h758V0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M380.6,90.6v20.8h96.1v33.4H367.2v-13.4h96.1v-6.6h-96.1V77.2H450v-6.6h-82.7V23.1h92.1v-6.6h-92.1V3.1h105.5 v33.4h-92.1v20.7h82.7v33.4L380.6,90.6L380.6,90.6z M548,131.4L588.1,3h36.3l-44.2,141.7h-14.4l40-128.5h-7.3l-40,128.5h-36.6 L477.6,3h36.3l33.5,107.8l-4.3,13.9h-5.8L503.6,16.3h-7.4l35.9,115.2L548,131.4L548,131.4z M629.2,3h126.4v33.4h-45.8v108.3H675 V36.5h-45.8V23.1H689v108.5h6.8V23.1h46.6v-6.6H629.2V3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M296,3h-6.7v141.7h6.7V3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.5,93.4c-6.2,0-10.8,2.5-13.2,7.5l-0.7-6.6h-5.5v50.4h6.4v-19.1c2.5,4,6.7,6.1,12,6.1 c10.5,0,16.3-6.8,16.3-19.2C44.8,100,39.5,93.4,29.5,93.4z M27.5,126.5c-6.4,0-11-4.1-11-13.9c0-9.9,4.8-14,11.3-14 c6.9,0,10.6,4.3,10.6,13.9C38.3,122,34.7,126.5,27.5,126.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.7,93.4c-7.2,0-12,2.1-14.7,6.1l3.6,3.9c2.1-2.8,5.2-4.9,10.5-4.9c6.4,0,9.7,2.4,9.8,9.9h-9.4 c-11.9,0-16,5.5-16,12.2c0,7,5.2,10.9,12.6,10.9c6.4,0,10.9-2.9,13.2-7.6l0.5,6.7h5.5v-22.3C82.3,97.1,76,93.4,66.7,93.4z  M75.9,113.6c-0.1,8.2-4.7,12.9-11.4,12.9c-5.4,0-7.7-2.2-7.7-6c0-4.8,2.8-7,9.8-7h9.3L75.9,113.6L75.9,113.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M95.9,102l-0.7-7.7h-5.5v36.4h6.4v-17.5c0.2-9.4,4.7-14.3,13.7-13.4v-6.1C103.6,93.3,98.4,96,95.9,102z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M131.8,126.1c-3.6,0-6.1-1.3-6.1-7.7V99.3h10.5v-5h-10.5V83.6h-6.3v10.7h-6.4v5h6.4v19.3c0,9.2,4.5,13,11.7,13 c2.1,0,3.6-0.2,6.2-1.1l-1.1-5.2C134.8,125.8,133.6,126.1,131.8,126.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175.8,93.4c-11.3,0-17.7,5.8-17.7,19c0,13.5,6.2,19.2,17.7,19.2c11.5,0,17.6-6.1,17.6-19.2 C193.4,99.1,187.6,93.4,175.8,93.4z M175.8,126.5c-7.6,0-11.2-3.7-11.2-14c0-10.3,3.4-13.9,11.2-13.9c7.6,0,11.2,3.6,11.2,13.9 C187,122.7,183.4,126.5,175.8,126.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M215.6,82.6c1.9,0,3.1,0.4,4.4,0.9l1.1-5.4c-1.6-0.7-3.9-1.1-5.9-1.1c-7.3,0-11.7,3.7-11.7,12.9v4.4h-6.7v5 h6.7v31.4h6.3V99.3h10.5v-5h-10.5v-4C209.8,84.3,212,82.6,215.6,82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.7,3.1h-6.4l-12,42.7L40.5,3.2H34L22.2,46.1l-11.7-43H3.6l15.3,52.3h6.4l11.8-42.8L49,55.4h6.3L70.7,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M103.9,47.3l-4.8-2.5c-2.2,5-5.5,6.4-10.7,6.4c-6.8,0-10.6-3.2-11-12h26.4c0.1-1.2,0.1-2.3,0.1-3.4 c0-10.1-4.8-17.6-15.6-17.6C77.1,18.1,71,24.8,71,37.2c0,13.2,6.3,19.1,17.2,19.1C95.4,56.3,100.9,53.6,103.9,47.3z M88.1,23.2 c5.8,0,9.2,3.1,9.5,11H77.5C78.1,26.2,81.8,23.2,88.1,23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M159.4,33.1c0-11.4-6.3-15-15.6-15c-7.2,0-12,2.1-14.7,6.1l3.6,3.9c2.1-2.8,5.2-4.9,10.5-4.9 c6.4,0,9.6,2.4,9.8,10h-9.4c-11.9,0-16,5.5-16,12.2c0,7,5.2,10.9,12.6,10.9c6.4,0,10.9-2.9,13.2-7.6l0.5,6.7h5.5L159.4,33.1 L159.4,33.1z M152.9,38.3c-0.1,8.2-4.7,12.9-11.4,12.9c-5.4,0-7.7-2.2-7.7-6c0-4.8,2.8-7,9.8-7h9.3L152.9,38.3L152.9,38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175.3,37.9c0.2-9.4,4.7-14.3,13.7-13.4v-6.1c-6.2-0.5-11.4,2.3-13.9,8.3l-0.7-7.7h-5.5v36.4h6.4V37.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M209.5,51.1c-6.8,0-10.5-3.2-11-12h26.4c0.1-1.2,0.2-2.3,0.2-3.4c0-10.1-4.8-17.6-15.6-17.6 c-11.3,0-17.4,6.7-17.4,19.1c0,13.2,6.3,19.1,17.2,19.1c7.2,0,12.7-2.7,15.6-9l-4.8-2.5C217.9,49.8,214.7,51.1,209.5,51.1z  M209.2,23.2c5.8,0,9.2,3.1,9.5,11h-20.1C199.2,26.2,202.9,23.2,209.2,23.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvtLogo);
export default __webpack_public_path__ + "static/media/evt-logo.e517af7077e65ec403f72f9ecfb8bc57.svg";
export { ForwardRef as ReactComponent };